import React from 'react';

const NotFound = () => {
    return (
        <div>
            <p>server connection lost 404 error</p>
        </div>
    );
};

export default NotFound;